import InternalLinkFinder from './InternalLinkFinder.component';

export default InternalLinkFinder;
